export default "__VITE_ASSET__C3ywRA8J__"